import { Absent_getInstance3t0okspv6nz5y as Absent_getInstance } from '../../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Optional.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  toString1pkumu07cwy4m as toString,
  getStringHashCode26igk1bx568vk as getStringHashCode,
  hashCodeq5arwsb9dgti as hashCode,
  equals2au1ep9vhcato as equals,
} from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var PinnedPlayerInputClass;
function PinnedPlayerInput() {
  if (PinnedPlayerInputClass === VOID) {
    class $ {
      constructor(id, name, email, badge, callSignAdjective, callSignNoun, imageURL, avatarType, unvalidatedEmails, pins) {
        badge = badge === VOID ? Absent_getInstance() : badge;
        imageURL = imageURL === VOID ? Absent_getInstance() : imageURL;
        avatarType = avatarType === VOID ? Absent_getInstance() : avatarType;
        this.u6p_1 = id;
        this.v6p_1 = name;
        this.w6p_1 = email;
        this.x6p_1 = badge;
        this.y6p_1 = callSignAdjective;
        this.z6p_1 = callSignNoun;
        this.a6q_1 = imageURL;
        this.b6q_1 = avatarType;
        this.c6q_1 = unvalidatedEmails;
        this.d6q_1 = pins;
      }
      toString() {
        return 'PinnedPlayerInput(id=' + this.u6p_1.toString() + ', name=' + this.v6p_1 + ', email=' + this.w6p_1 + ', badge=' + toString(this.x6p_1) + ', callSignAdjective=' + this.y6p_1 + ', callSignNoun=' + this.z6p_1 + ', imageURL=' + toString(this.a6q_1) + ', avatarType=' + toString(this.b6q_1) + ', unvalidatedEmails=' + toString(this.c6q_1) + ', pins=' + toString(this.d6q_1) + ')';
      }
      hashCode() {
        var result = this.u6p_1.hashCode();
        result = imul(result, 31) + getStringHashCode(this.v6p_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.w6p_1) | 0;
        result = imul(result, 31) + hashCode(this.x6p_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.y6p_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.z6p_1) | 0;
        result = imul(result, 31) + hashCode(this.a6q_1) | 0;
        result = imul(result, 31) + hashCode(this.b6q_1) | 0;
        result = imul(result, 31) + hashCode(this.c6q_1) | 0;
        result = imul(result, 31) + hashCode(this.d6q_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof PinnedPlayerInput()))
          return false;
        if (!this.u6p_1.equals(other.u6p_1))
          return false;
        if (!(this.v6p_1 === other.v6p_1))
          return false;
        if (!(this.w6p_1 === other.w6p_1))
          return false;
        if (!equals(this.x6p_1, other.x6p_1))
          return false;
        if (!(this.y6p_1 === other.y6p_1))
          return false;
        if (!(this.z6p_1 === other.z6p_1))
          return false;
        if (!equals(this.a6q_1, other.a6q_1))
          return false;
        if (!equals(this.b6q_1, other.b6q_1))
          return false;
        if (!equals(this.c6q_1, other.c6q_1))
          return false;
        if (!equals(this.d6q_1, other.d6q_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'PinnedPlayerInput');
    PinnedPlayerInputClass = $;
  }
  return PinnedPlayerInputClass;
}
//region block: exports
export {
  PinnedPlayerInput as PinnedPlayerInput1hnlnl1bk4or8,
};
//endregion

//# sourceMappingURL=PinnedPlayerInput.mjs.map
